import { createRoot } from 'react-dom/client'; // Import createRoot from react-dom/client
import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = createRoot(document.getElementById('root')); // Create a root using createRoot
root.render(<App />);

reportWebVitals();